export class UpdateAssetCommand {
    constructor(asset) {
        this.asset = asset;
    }
}
//# sourceMappingURL=update-asset.command.js.map